import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';

const Greeting = ({ user }) => {
  const [greeting, setGreeting] = useState('');
  const [color, setColor] = useState('text.primary');

  const updateGreeting = () => {
    const hour = new Date().getHours();

    if (hour < 12) {
      setGreeting('Good Morning');
      setColor('#FFA726'); // Orange
    } else if (hour < 17) {
      setGreeting('Good Afternoon');
      setColor('#29B6F6'); // Blue
    } else if (hour < 20) {
      setGreeting('Good Evening');
      setColor('#9AB7BC'); // Purple
    } else {
      setGreeting('Good Night');
      setColor('#0FFDE4'); // Greyish Blue
    }
  };

  useEffect(() => {
    updateGreeting(); // Initial greeting
    const interval = setInterval(updateGreeting, 60 * 1000); // Update every minute
    return () => clearInterval(interval); // Cleanup
  }, []);

  return (
    <Typography variant="h6">
      <span style={{ color, fontWeight: 500 }}>{greeting}</span>{' '}
      <span>{user.name || user.role}</span>
    </Typography>
  );
};

export default Greeting;
